import type { FC } from 'react';
import React from 'react';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';

import type { TTabs } from './models';

/**
 * Табы для переключения контента в форме
 */
export const FormTabs: FC<React.PropsWithChildren<TTabs>> = ({
    Text,
    BaseTabs,
    Field,
    className,
    name,
    settings = {},
    children,
    getCaption,
    isError,
    initialValue,
    selectedID,
    validateNotEmpty,
    dataTestId,
    containerDataTestId,
}) => (
    <Field<string>
        initialValue={initialValue}
        name={name}
        render={({ input, meta }) => {
            const { name: inputName, value, ...restInputProps } = input;

            // TODO: чтобы убрать ts-ignore, нужно разобраться с правильной типизацией children в models
            // сейчас везде optional, но из-за этого возникает ошибка, т.к. BaseTabs должен иметь потомка
            return (
                <div className={className}>
                    {/* @ts-ignore */}
                    <BaseTabs
                        {...restInputProps}
                        dataTestId={containerDataTestId}
                        onChange={({ id }) => {
                            actions.onSelect({ input, meta })(String(id));
                        }}
                        scroll={settings.scroll}
                        selectedID={selectedID || value}
                        size={settings.size}
                    >
                        {children}
                    </BaseTabs>
                    {isError(meta) && (
                        <Text
                            dataTestId={`${dataTestId}-error-caption`}
                            kind="red"
                            styler={{ marginTop: 4 }}
                            tag="div"
                            view="primary-small"
                        >
                            {getCaption(meta)}
                        </Text>
                    )}
                    <input name={inputName} type="hidden" value={value} />
                </div>
            );
        }}
        validate={validateNotEmpty()}
    />
);
